import { css } from '@emotion/css'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React, { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import { FormattedMessage } from 'react-intl/lib'
import Chip from '../../../../../components/Chips/Chip'
import chipsStyles from '../../../../../components/Chips/styles/chipsStyles'
import DatesStore from '../../../../../stores/DatesStore'
import { getStyles } from '../../../../../utils/utils/commonUtils'
import { getComp } from '../../../../../utils/utils/DI'

function RequestFilterChip({
  propName,
  value,
  onClick,
  isStatistic,
  isCheckEquipment,
}) {
  const classes = getStyles(chipsStyles)
  const intl = useIntl()
  const {
    senderGroups,
    getStatusImage,
    getStatusName,
    getDataCheckingStatusName,
    getFinancialSourceElement,
    getAgreementStatusData,
    getAgreementStatus,
  } = getComp('StatusesStore')
  const { getCategoryName } = getComp('CategoriesStore')
  const { getName } = getComp('AuthorsStore')
  const { getDealerBuyAid, getDealer } = getComp('DealersStore')
  const { getInstallationReasonName } = getComp('InstallationReasonStore')
  const { getSourceName } = getComp('SourcesStore')
  const { getSenderName } = getComp('SendersStore')
  const [datesStore] = useState(new DatesStore())

  const setChipAction = useCallback(() => {
    return onClick
      ? () => onClick(propName, value === 'Без приоритета' ? '' : value)
      : null
  }, [value])

  const setValue = useCallback(() => {
    switch (propName) {
      case 'statuses':
      case 'status': {
        if (isCheckEquipment) {
          const status = getAgreementStatus(value)

          return (
            <Box className={'aln-center'}>
              <img
                alt={''}
                src={status?.imageSrc}
                className={css(classes.statusIcon)}
              />
              <Typography variant={'body1'} sx={classes.chipText}>
                {status?.name}
              </Typography>
            </Box>
          )
        }
        return (
          <Box className={'aln-center'}>
            <img
              alt={''}
              src={getStatusImage(value)}
              className={css(classes.statusIcon)}
            />
            <Typography variant={'body1'} sx={classes.chipText}>
              {getStatusName(value)}
            </Typography>
          </Box>
        )
      }

      case 'financialSourceIds': {
        const data = getFinancialSourceElement(value)
        return (
          <Box className={'aln-center'}>
            <img
              alt={''}
              src={data.imageSrc}
              className={css(classes.statusIcon)}
            />
            <Typography variant={'body1'} sx={classes.chipText}>
              {data.name}
            </Typography>
          </Box>
        )
      }
      case 'dataCheckingStatus':
      case 'dataCheckingStatuses': {
        return getDataCheckingStatusName(value)
      }
      case 'agreementCheckingStatus': {
        const data = getAgreementStatusData(value)
        return (
          <Box className={'aln-center'}>
            <img
              alt={''}
              src={data.imageSrc}
              className={css(classes.statusIcon)}
            />
            <Typography variant={'body1'} sx={classes.chipText}>
              {data.name}
            </Typography>
          </Box>
        )
      }
      case 'source': {
        return getSourceName(value)
      }
      case 'categories': {
        return getCategoryName(value)
      }
      case 'lastMoved': {
        return intl.formatMessage({ id: 'Перемещение' }) + ' ' + value
      }
      case 'from': {
        return intl.formatMessage({ id: 'Создана' }) + ' ' + value
      }
      case 'installedFrom': {
        return intl.formatMessage({ id: 'Установлено' }) + ' ' + value
      }
      case 'subjectList':
      case 'authorId': {
        return getName(value) ? getName(value).name : value
      }
      case 'sender': {
        return getSenderName(value) || value
      }
      case 'dealerIds':
      case 'dealerId':
      case 'dealer': {
        if (isCheckEquipment) {
          return getDealer(value) ? getDealer(value).displayName : ''
        } else if (!isStatistic) {
          return getDealerBuyAid(value)
            ? getDealerBuyAid(value).displayName
            : ''
        } else {
          return value
        }
      }
      case 'reasonId': {
        let result = getInstallationReasonName(value)
        if (result === 'Замена') {
          result = result + ' (Горыныч)'
        }
        return result
      }
      case 'hasDuplicates': {
        return <FormattedMessage id={'Повторное обращение'} />
      }
      case 'priority': {
        return <FormattedMessage id={'Приоритет'} />
      }
      case 'reportMonth': {
        return datesStore.getMonthName(value, false, true)
      }
      case 'subpage': {
        return value.name
      }
      case 'SenderGroupIds': {
        return senderGroups.find((el) => el.id === value).name
      }
      case 'isExpired': {
        return <FormattedMessage id={'Просроченные заявки'} />
      }
      case 'isSuspicious': {
        return <FormattedMessage id={'Отмеченные как подозрительные'} />
      }
      default: {
        return value
      }
    }
  }, [value, isStatistic, isCheckEquipment])

  return <Chip action={setChipAction()} value={setValue()} />
}

export default observer(RequestFilterChip)
